import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_DE.json';
import recipes from './COOKING_RECIPES_DE.json';
import videos from './COOKING_VIDEOS_DE.json';

export const COOKING_DATA_DE: ServiceData = {
  articles,
  recipes,
  videos,
};
